import { adminClientMessage, AdminResErrorType } from '../../../config/adminRequest';
import { Button, Card, Form, Input, Modal, Spin, Tabs } from 'antd';
import React, { RefObject, useEffect, useState } from 'react';
import { FormInstance } from 'antd/lib/form';
import { FeeSetting } from '../../domain/usdt-providers/systemProvider';
import CoreDrawer from '../../core/components/CoreDrawer';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { useOperatorLogger } from '../../core/hooks/useOperatorLogger';
import { ProFormSwitch } from '@ant-design/pro-form';
import PayforTokenSettingForm from '../../domain/components/setttings/PayforTokenSettingForm';
import * as _ from 'lodash';
import PayforSettingProvider, { PayforSetting } from '../../domain/usdt-providers/payforSettingProvider';

export enum SystemSettingActionType {
  AddAgent,
  AddNormal,
  Extend,
  Edit,
}

const fromEditErrorModel = (
  err: AdminResErrorType,
  state: { type: string },
) => {
  Modal.error({
    title: state.type,
    content: (
      <div>
        <ul>
          <li>原因: {adminClientMessage.get(err.clientCode) ?? err.message}</li>
          {err.clientCode === 'feeRate.check.error' ? (
            <>
              <li>欄位: {err.data.colName}</li>
              <li>最小值: {err.data.min}</li>
              <li>最大值: {err.data.max}</li>
            </>
          ) : (
            <></>
          )}
        </ul>
      </div>
    ),
    okText: '確認',
  });
};

const initPayforSettingData = {

  systemId: '',
  notifyChannelFlag: true,
  notifyTokenFlag: false,
  notifyUrl: '',
  tokenSetting: {
    ETHEREUM: {
      USDT: {
        active: true,
        feeRate: 0,
        minimumAmount: 0,
        payoutFee: 0,
        payoutOption: 'rate',
      },
      ETH: {
        active: true,
        feeRate: 0,
        minimumAmount: 0,
        payoutFee: 0,
        payoutOption: 'rate',
      },
    },
    TRON: {
      USDT: {
        active: true,
        feeRate: 0,
        minimumAmount: 0,
        payoutFee: 0,
        payoutOption: 'rate',
      },
      TRX: {
        active: true,
        feeRate: 0,
        minimumAmount: 0,
        payoutFee: 0,
        payoutOption: 'rate',
      },
    },
    SOLANA: {
      USDT: {
        active: true,
        feeRate: 0,
        minimumAmount: 0,
        payoutFee: 0,
        payoutOption: 'rate',
      },
    },
  },
  networkFeeSetting:{
    ETHEREUM: {
      USDT: {
        transferMode:'',
      },
      ETH: {
        transferMode:'',
      },
    },
    TRON: {
      USDT: {
        transferMode:'',
      },
      TRX: {
        transferMode:'',
      },
    },
    XRP: {
      XRP: {
        transferMode:'',
      },
    },
    SOLANA: {
      USDT: {
        transferMode:'',
      },
    },},
};

enum ActionType {
  Closed,
}

const formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

const PayforSettingForm = (props: {
  type: SystemSettingActionType;
  payforNotifyChannelFlag: boolean;
  visible: boolean;
  closeForm: () => void;
  systemId: string;
}) => {
  let keyNumber = 2;
  const [feeRange, setfeeRange] = useState<FeeSetting>({

      ETHEREUM: {
        USDT: {
          max: 0,
          min: 0,
        },
        ETH: {
          max: 0,
          min: 0,
        },
      },
      TRON: {
        USDT: {
          max: 0,
          min: 0,
        },
        TRX: {
          max: 0,
          min: 0,
        },
      },
      SOLANA: {
        USDT: {
          max: 0,
          min: 0,
        },
      },
      BSC: {
        BUSD: {
          max: 0,
          min: 0,
        },
        USDT: {
          max: 0,
          min: 0,
        },
        USDC: {
          max: 0,
          min: 0,
        }
      },
      XRP: {
        XRP: {
          max: 0,
          min: 0,
        },
      },
    }
  );
  const [actionState] = useState(new Subject<ActionType>());
  useEffect(() => {
    actionState.pipe(filter((x) => x === ActionType.Closed)).subscribe((x) => {
      props.closeForm();
    });
    // eslint-disable-next-line
  }, [actionState]);
  const [actionType, setActionType] = useState<SystemSettingActionType>(
    props.type,
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<PayforSetting>(initPayforSettingData);
  useEffect(() => {
    if (props.systemId) {
      PayforSettingProvider.getFeeRateRange(props.systemId).then((data) => {
        setfeeRange(data);
      });
    }
  }, [props.systemId, props.visible]);

  const opLogger = useOperatorLogger();

  const successHandle = () => {
    if (formRef.current) formRef.current.resetFields();
    actionState.next(ActionType.Closed);
  };

  const formSave = () => {
    if (formRef.current) {
      switch (actionType) {
        case SystemSettingActionType.Edit:
          if (props.systemId)
            formRef.current.validateFields().then((value) => {

              for (const channel in data.tokenSetting) {
                const tokenList = data.tokenSetting[channel];
                for (const token in tokenList) {
                  data.tokenSetting[channel][token].feeRate = value[`${channel}_${token}_feeRate`] ??
                    data.tokenSetting[channel][token].feeRate;
                  data.tokenSetting[channel][token].minimumAmount = value[`${channel}_${token}_minimumAmount`] ??
                    data.tokenSetting[channel][token].minimumAmount;
                  data.tokenSetting[channel][token].payoutFee = value[`${channel}_${token}_payoutFee`] ??
                    data.tokenSetting[channel][token].payoutFee;
                  data.tokenSetting[channel][token].payoutOption = value[`${channel}_${token}_payoutOption`] ??
                    data.tokenSetting[channel][token].payoutOption;

                  data.networkFeeSetting[channel][token].transferMode = value[`${channel}_${token}_transferMode`] ??
                    data.networkFeeSetting[channel][token].transferMode;
                  data.networkFeeSetting[channel][token].staticFee = value[`${channel}_${token}_staticFee`] ??
                    data.networkFeeSetting[channel][token].staticFee;
                }
              }

              const d = JSON.parse(JSON.stringify(data));
              const v = JSON.parse(JSON.stringify(value));
              const req = { ...d, ...v };

              PayforSettingProvider.updateSetting(
                { ...d, ...v },
                // metaData.curSystemId!,
              ).then(
                (rss) => {
                  Modal.success({
                    content: '修改成功',
                    okText: '確認',
                    onOk: () => successHandle(),
                  });
                  opLogger.log({
                    action: '修改',
                    payload: {
                      req: req,
                      res: rss,
                    },
                    systemId: props.systemId,
                  });
                },
                (err) => {
                  fromEditErrorModel(err as any, { type: '更新失敗' });
                  opLogger.log({
                    action: '修改',
                    payload: {
                      req: req,
                      res: err,
                    },
                    systemId: props.systemId,
                  });
                },
              );

            });
          break;
      }
    }
  };
  useEffect(() => {
    setActionType(props.type);
  }, [props.type]);

  useEffect(() => {
    if (props.systemId && props.visible) {
      setLoading(true);
      PayforSettingProvider.getSetting(props.systemId)
        .then((data) => {
          formRef.current?.setFieldsValue({
            'notifyUrl': data.notifyUrl,
            notifyChannelFlag: data.notifyChannelFlag,
            notifyTokenFlag: data.notifyTokenFlag,
          })
          setData(data);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.systemId, actionType, props.visible]);

  return (
    <>
      <CoreDrawer
        title={'編輯代付設定'}
        width={640}
        visible={props.visible}
        onClose={() => {
          actionState.next(ActionType.Closed);
        }}
        destroyOnClose={true}
        footerbuttons={[
          <Button key={1} onClick={formSave}>
            送出
          </Button>,
        ]}
      >
        <Spin spinning={loading}>
          <Form
            ref={formRef}
            layout='vertical'
            name='systemSettingForm'
            initialValues={data}
          >
            <Tabs type='card'>
              <Tabs.TabPane key={1} tab='基本設定'>
                <Form.Item name='notifyUrl' label='代付通知地址'>
                  <Input />
                </Form.Item>
                <Card title='版本設定' style={{ marginBottom: 16 }}>
                  <ProFormSwitch
                    disabled={data.notifyChannelFlag}
                    name='notifyChannelFlag'
                    label='新版代付通知'
                    tooltip={'舊版代付通知已棄用請協助商戶調整'}
                  />
                  <ProFormSwitch
                    disabled={data.notifyTokenFlag}
                    name='notifyTokenFlag'
                    label='回調包含代幣(Token)'
                    tooltip={'舊版代付通知已棄用請協助商戶調整'}
                  />
                </Card>
              </Tabs.TabPane>
              {
                _.map(data.tokenSetting, (channelObj, channel) => {
                  let isTokenActive = false;
                  _.map(channelObj, (tokenObj, token) => {
                    if (tokenObj.active) {
                      isTokenActive = true;
                    }
                  });
                  if (isTokenActive) {
                    keyNumber++;
                    return (
                      <Tabs.TabPane key={keyNumber} tab={channel}>
                        <PayforTokenSettingForm
                          feeRange={feeRange}
                          channel={channel}
                          data={channelObj}
                          networkFeeSetting={data.networkFeeSetting}
                        />
                      </Tabs.TabPane>
                    );
                  }
                })
              }
            </Tabs>
          </Form>
        </Spin>
      </CoreDrawer>
    </>
  );
};

export default PayforSettingForm;
